import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import PlanReview from "./PlanReview";
import PlansDataTable from "./PlansDataTable";
import NavigationBar from "@safecv/core/NavigationBar";
import ManagePreferencesModal from "@safecv/core/ManagePreferencesModal";

import { resetJuridiction } from "@safecv/src/Actions/types";
import { PROFILE_PREFERENCE } from "@safecv/shared/appConstant";

const Plan = (props) => {
  const [
    ManagePreferencesModalState,
    setManagePreferencesModalState,
  ] = useState(false);

  const closeModalForPreferences = () => {
    setManagePreferencesModalState(false);
  };
  useEffect(() => {
    props.jurisdictions.length > 0 && props.resetJuridiction();
    let preference = JSON.parse(localStorage.getItem(PROFILE_PREFERENCE));

    if (_.isEmpty(preference)) setManagePreferencesModalState(true);
    else if (preference.hasOwnProperty("output")) {
      setManagePreferencesModalState(false);
    } else {
      setManagePreferencesModalState(true);
    }
  }, []);

  return (
    <div>
      <NavigationBar />
      <PlanReview />
      <PlansDataTable />
      {ManagePreferencesModalState && (
        <ManagePreferencesModal
          closeModalForPreferences={closeModalForPreferences}
          modalState={ManagePreferencesModalState}
          canBeClosed={false}
          canBeSaved={true}
        />
      )}
    </div>
  );
};

const mapStatetoProps = (state) => ({
  jurisdictions: state.criteria.jurisdictions,
  preference: state.criteria.preference,
});

const mapDispatchtoProps = (dispatch) => {
  return {
    resetJuridiction: () => {
      dispatch(resetJuridiction());
    },
  };
};

export default connect(mapStatetoProps, mapDispatchtoProps)(Plan);
